const CrudModal = ({
  title,
  children,
  onClose,
  onSubmit,
  submitLabel = 'Enregistrer',
  submitting = false,
}) => (
  <div className="crm-modal-backdrop" onClick={onClose}>
    <div className="crm-modal" onClick={(event) => event.stopPropagation()}>
      <div className="crm-modal__header">
        <h3>{title}</h3>
        <button type="button" className="crm-modal__close" onClick={onClose}>
          ×
        </button>
      </div>

      <form onSubmit={onSubmit} className="crm-form">
        <div className="crm-form__body">{children}</div>
        <div className="crm-form__footer">
          <button type="button" className="crm-btn-secondary" onClick={onClose}>
            Annuler
          </button>
          <button type="submit" className="crm-btn-primary" disabled={submitting}>
            {submitting ? 'Enregistrement...' : submitLabel}
          </button>
        </div>
      </form>
    </div>
  </div>
);

export default CrudModal;
